export const WIDTH_QR_CODE_SECTION = 315;

export const FOOTER_BACKGROUND_OPACITY = 1;
